import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}

export default new Router({
    routes: [{
        path: "/",
        name: "home",
        redirect: "login"
    },
    {
        path: "/signup",
        name: "signup",
        component: () =>
            import("@/views/signup/signupPage"),
        meta: {
            title: "在线报名"
        }
    },
    {
        path: "/signupSearch",
        name: "signupSearch",
        component: () =>
            import("@/views/signup/signupSearch"),
        meta: {
            title: "报名查询"
        }
    },
    {
        path: "/login",
        name: "login",
        component: () =>
            import("@/views/login"),
        meta: {
            title: "登录"
        }
    },
    {
        path: "/meetLogin",
        name: "meetLogin",
        component: () =>
            import("@/views/login/meetLogin"),
        meta: {
            title: "会议登录"
        }
    },
    {
        path: "/meetRegister",
        name: "meetRegister",
        component: () =>
            import("@/views/register/meetRegister/index"),
        meta: {
            title: "会议注册"
        }
    },
    {
        path: "/register",
        name: "registerBox",
        component: () =>
            import("../views/login/register.vue"),
        meta: {
            title: "账号注册"
        }
    },
    {
        path: "/registerUploadAttachments",
        name: "registerUploadAttachments",
        component: () =>
            import("../views/register/person/uploadAttachments.vue"),
        meta: {
            title: "账号注册"
        }
    },
    {
        path: "/memberUploadAttachments",
        name: "memberUploadAttachments",
        component: () =>
            import("../views/MemberCenter/memberUploadAttachments.vue"),
        meta: {
            title: "附件"
        }
    },
    {
        path: "/uploadAttachments",
        name: "uploadAttachments",
        component: () =>
            import("../views/MemberCenter/uploadAttachments.vue"),
        meta: {
            title: "附件"
        }
    },
    {
        path: "/groupUploadAttachments",
        name: "groupUploadAttachments",
        component: () =>
            import("../views/register/group/uploadAttachments.vue"),
        meta: {
            title: "注册"
        }
    },
    {
        path: "/getPassword",
        name: "getPassword",
        component: () =>
            import("@/views/getPassword/index"),
        meta: {
            title: "查找密码"
        }
    },
    {
        path: "/memberInfo",
        name: "memberInfo",
        component: () =>
            import("@/views/MemberCenter/memberInfo"),
        meta: {
            title: "会员信息"
        }
    },
    {
        path: "/MemberCenter",
        name: "MemberCenter",
        component: () =>
            import("@/views/MemberCenter/Member"),
        meta: {
            title: "会员中心"
        }
    },
    {
        path: "/uploadAttachments",
        name: "uploadAttachments",
        component: () =>
            import("@/views/MemberCenter/uploadAttachments"),
        meta: {
            title: "附件上传"
        }
    },
    {
        path: "/ChangePassword",
        name: "ChangePassword",
        component: () =>
            import("@/views/MemberCenter/ChangePassword"),
        meta: {
            title: "修改密码"
        }
    },
    {
        path: "/bindUser",
        name: "bindUser",
        component: () =>
            import("@/views/MemberCenter/bindUser"),
        meta: {
            title: "账号绑定"
        }
    },
    {
        path: "/MembershipCard",
        name: "MembershipCard",
        component: () =>
            import("@/views/MemberCenter/MembershipCard"),
        meta: {
            title: "电子会员证"
        }
    },
    {
        path: "/dlxhMembershipCard",
        name: "dlxhMembershipCard",
        component: () =>
            import("@/views/MemberCenter/dlxhMembershipCard"),
        meta: {
            title: "电子会员证"
        }
    },
    {
        path: "/TfxqMembershipCard",
        name: "TfxqMembershipCard",
        component: () =>
            import("@/views/MemberCenter/TfxqMembershipCard"),
        meta: {
            title: "电子会员证"
        }
    },
    {
        path: "/lbjMembershipCard",
        name: "lbjMembershipCard",
        component: () =>
            import("@/views/MemberCenter/lbjMembershipCard"),
        meta: {
            title: "电子会员证"
        }
    },
        {
            path: "/wbMembershipCard",
            name: "wbMembershipCard",
            component: () =>
                import("@/views/MemberCenter/wbMembershipCard"),
            meta: {
                title: "电子会员证"
            }
        },
    {
        path: "/stationMessage",
        name: "stationMessage",
        component: () =>
            import("@/views/MemberCenter/stationMessage"),
        meta: {
            title: "站内信"
        }
    },
    {
        path: "/stationDetail",
        name: "stationDetail",
        component: () =>
            import("@/views/MemberCenter/stationDetail"),
        meta: {
            title: "站内信详情"
        }
    },
    {
        path: "/PaymentList",
        name: "PaymentList",
        component: () =>
            import("@/views/MemberCenter/PaymentList"),
        meta: {
            title: "缴费列表"
        }
    },
    {
        path: "/payMeeting",
        name: "payMeeting",
        component: () =>
            import("@/views/MeetingCenter/meetingPay"),
        meta: {
            title: "会议缴费列表"
        }
    },
    {
        path: "/OfflinePayment",
        name: "OfflinePayment",
        component: () =>
            import("@/views/MemberCenter/OfflinePayment"),
        meta: {
            title: "缴费列表"
        }
    },
    {
        path: "/paymentPage",
        name: "paymentPage",
        component: () =>
            import("@/views/MemberCenter/paymentPage"),
        meta: {
            title: "缴纳会费"
        }
    },
    {
        path: "/onlinePayment",
        name: "onlinePayment",
        component: () =>
            import("@/views/MemberCenter/onlinePayment"),
        meta: {
            title: "线上缴费"
        }
    },
    {
        path: "/MeetingList",
        name: "MeetingList",
        component: () =>
            import("@/views/MeetingCenter/MeetingList.vue"),
        meta: {
            title: "会议中心"
        }
    },
    {
        path: "/signUpPage",
        name: "signUpPage",
        component: () =>
            import("@/views/MeetingCenter/companySignUp/signUpPage.vue"),
        meta: {
            title: "会议报名"
        }
    },
    {
        path: "/meetPaymentList",
        name: "meetPaymentList",
        component: () =>
            import("@/views/MeetingCenter/companySignUp/PaymentList.vue"),
        meta: {
            title: "缴费"
        }
    },
    {
        path: "/addPerson",
        name: "addPerson",
        component: () =>
            import("@/views/MeetingCenter/companySignUp/addPerson.vue"),
        meta: {
            title: "添加参会人员"
        }
    },
    {
        path: "/vote",
        name: "vote",
        component: () =>
            import("@/views/vote/vote.vue"),
        meta: {
            title: "投票选举"
        }
    },
    {
        path: "/voteDetails",
        name: "voteDetails",
        component: () =>
            import("@/views/vote/voteDetails.vue"),
        meta: {
            title: "投票选举详情"
        }
    },
    {
        path: "/voteResult",
        name: "voteResult",
        component: () =>
            import("@/views/vote/voteResult.vue"),
        meta: {
            title: "投票结果"
        }
    },
    // {
    //     path: "/offlinePaymentHydro",
    //     name: "offlinePaymentHydro",
    //     component: () =>
    //         import ("@/views/MemberCenter/offlinePaymentHydro.vue"),
    //     meta: {
    //         title: "线下缴费"
    //     }
    // },
    {
        path: "/MeetingListDetails",
        name: "MeetingListDetails",
        component: () =>
            import("@/views/MeetingCenter/MeetingListDetails.vue"),
        meta: {
            title: "会议详情"
        }
    },
    {
        path: "/MeetingCenter",
        name: "MeetingCenter",
        component: () =>
            import("@/views/MeetingCenter/Meeting.vue"),
        meta: {
            title: "会议中心"
        }
    },
    {
        path: "/memberStyleDetail",
        name: "memberStyleDetail",
        component: () =>
            import("@/views/MemberCenter/memberStyleDetail.vue"),
        meta: {
            title: "会员风采详情"
        }
    },
    {
        path: "/invoiceList",
        name: "invoiceList",
        component: () =>
            import("@/views/invocie/invoiceList.vue"),
        meta: {
            title: "发票列表表"
        }
    },
    {
        path: "/applyInvoice",
        name: "applyInvoice",
        component: () =>
            import("@/views/invocie/applyInvoice.vue"),
        meta: {
            title: "申请开票"
        }
    },
    {
        path: "/mailManage",
        name: "mailManage",
        component: () =>
            import("@/views/invocie/mailManage.vue"),
        meta: {
            title: "邮件管理"
        }
    },
    {
        path: "/invoiceHome",
        name: "invoiceHome",
        component: () =>
            import("@/views/invocie/invoiceHome.vue"),
        meta: {
            title: "发票管理"
        }
    },
    {
        path: "/memberStyle",
        name: "memberStyle",
        component: () =>
            import("@/views/MemberCenter/memberStyle.vue"),
        meta: {
            title: "会员风采"
        }
    },
    {
        path: "/resourceSharing",
        name: "resourceSharing",
        component: () =>
            import("@/views/MemberCenter/resourceSharing.vue"),
        meta: {
            title: "资源共享"
        }
    },
    {
        path: "/preview",
        name: "preview",
        component: () =>
            import("@/views/MemberCenter/preview.vue"),
        meta: {
            title: "在线预览"
        }
    },
    {
        path: "/PaperList",
        name: "PaperList",
        component: () =>
            import("@/views/MeetingCenter/PaperList.vue"),
        meta: {
            title: "会议论文列表"
        }
    },
    {
        path: "/hotelList",
        name: "hotelList",
        component: () =>
            import("@/views/MeetingCenter/hotelList.vue"),
        meta: {
            title: "酒店列表"
        }
    },
    {
        path: "/hotel",
        name: "hotel",
        component: () =>
            import("@/views/MeetingCenter/hotel.vue"),
        meta: {
            title: "酒店预定"
        }
    },
    {
        path: "/EnrolledMeeting",
        name: "EnrolledMeeting",
        component: () =>
            import("@/views/MeetingCenter/EnrolledMeeting.vue"),
        meta: {
            title: "已报名会议"
        }
    },
    {
        path: "/signUp",
        name: "signUp",
        component: () =>
            import("@/views/MeetingCenter/signUp.vue"),
        meta: {
            title: "立即报名"
        }
    },
    {
        path: "/MeetingDetails",
        name: "MeetingDetails",
        component: () =>
            import("@/views/MeetingCenter/MeetingDetails.vue"),
        meta: {
            title: "会议详情"
        }
    },
    {
        path: "/signUpMeeting",
        name: "signUpMeeting",
        component: () =>
            import("@/views/MeetingCenter/signUpMeeting/home.vue"),
        meta: {
            title: "会议详情"
        }
    },
    {
        path: "/register",
        name: "register",
        component: () =>
            import("@/views/register/index.vue"),
        children: [{
            path: "/quick",
            name: "quick",
            component: () =>
                import("@/views/register/quick.vue"),
            meta: {
                title: "快捷注册"
            }
        },
        {
            path: "/person",
            name: "personRegister",
            component: () =>
                import("@/views/register/person/index.vue"),
            meta: {
                title: "个人账号注册"
            }
        },
        {
            path: "/group",
            name: "groupRegister",
            component: () =>
                import("@/views/register/group/index.vue"),
            meta: {
                title: "单位账号注册"
            }
        }
        ]
    },
    {
        path: "/rule",
        name: "rule",
        component: () =>
            import("@/views/rule"),
        meta: {
            title: "入会须知"
        }
    },
    {
        path: "/editMember",
        name: "editMember",
        component: () =>
            import("@/views/register/editMember"),
        meta: {
            title: "入会申请表"
        }
    },
    {
        path: "/member",
        name: "member",
        component: () =>
            import("@/views/register/member.vue"),
        meta: {
            title: "入会申请表"
        }
    },
    {
        path: "/noticeList",
        name: "noticeList",
        component: () =>
            import("@/views/MemberCenter/notice/noticeList"),
        meta: {
            title: "通知公告"
        }
    },
    {
        path: "/noticeDetails",
        name: "noticeDetails",
        component: () =>
            import("@/views/MemberCenter/notice/noticeDetails"),
        meta: {
            title: "通知公告详情"
        }
    },
    {
        path: "/feedback",
        name: "feedback",
        component: () =>
            import("@/views/MemberCenter/feedback"),
        meta: {
            title: "问题反馈"
        }
    },
    {
        path: "/fsHome",
        name: "fsHome",
        component: () =>
            import("@/views/forestrySociety/home"),
        meta: {
            title: "资源共享"
        }
    },
    {
        path: "/my",
        name: "my",
        component: () =>
            import("@/views/forestrySociety/my"),
        meta: {
            title: "问题反馈"
        }
    },
    {
        path: "/proposalElection",
        name: "proposalElection",
        component: () =>
            import("@/views/MemberCenter/proposalElection/electionList"),
        meta: {
            title: "投票选举"
        }
    },
    {
        path: "/electionVote",
        name: "electionVote",
        component: () =>
            import("@/views/MemberCenter/proposalElection/electionVote"),
        meta: {
            title: "去投票"
        }
    },
    {
        path: "/candidateList",
        name: "candidateList",
        component: () =>
            import("@/views/MemberCenter/proposalElection/candidateList"),
        meta: {
            title: "我要成为候选人"
        }
    },
    {
        path: "/candiDate",
        name: "candiDate",
        component: () =>
            import("@/views/MemberCenter/proposalElection/candiDate"),
        meta: {
            title: "成为候选人"
        }
    },
    {
        path: "/candiDateReason",
        name: "candiDateReason",
        component: () =>
            import("@/views/MemberCenter/proposalElection/candiDateReason"),
        meta: {
            title: "成为候选人"
        }
    },
    ]
});
